'use client'

import React, { Suspense } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import LayoutPage from '@/entities/LayoutPage'
//state,store
//toast
import 'react-toastify/dist/ReactToastify.css'
import ToastProvider from './ToastProvider'
import StoreProvider from './StoreProvider'
import CookieWarning from '@/widgets/CokkieWarning'


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
})

export function Providers({ children }) {
    return (
        <StoreProvider>
            <QueryClientProvider client={queryClient}>
                <ToastProvider>
                    <Suspense
                        fallback={
                            <div
                                style={{
                                    width: 0,
                                    height: 0,
                                    visibility: 'hidden',
                                    position: 'absolute',
                                    top: -3000,
                                }}
                            >
                                {children}
                            </div>
                        }
                    >
                        <CookieWarning />
                        <LayoutPage>{children}</LayoutPage>
                    </Suspense>
                </ToastProvider>
            </QueryClientProvider>
        </StoreProvider>

    )
}
